export * from './tooltip';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// /home/backend/KreditCentr/WebLombard/client/~/@angular/material/tooltip/index.js
// module id = ../../../material/tooltip/index.js
// module chunks = 3